module.exports = __webpack_public_path__ + "static/media/creative-commons-pd-alt.fe289298.svg";